import React from 'react';
import { View } from 'react-native';
import { rem } from 'design-system/values';
export const ControlsRow = (props) => (<View {...props} style={styles.container}/>);
const styles = {
    container: {
        marginHorizontal: rem(16),
        marginTop: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
};
